module.exports = __webpack_public_path__ + "img/9791158880002.8fe5feaa.jpg";